export default "__VITE_ASSET__FRl0mCZe__"